module.exports = __webpack_public_path__ + "img/营地图标.7f4788aa.jpg";